import React from 'react'
import styled from 'styled-components'

const PremButton = ({ pad = "15px 10px", children, selected = true, handleClick, colorName, isDisabled = false, hex = "", accent = false, fullWidth = false, mobileText = "" }) => {



    return (
        <Wrap disabled={isDisabled} $fullWidth={fullWidth} $accent={accent} onClick={handleClick} $selected={selected} >
            <OuterButtonWrap>
                <InnerButtonWrap $selected={selected} $selectcolor={hex}>
                    <InnerText $selected={selected} >{mobileText !== "" ? mobileText : children}</InnerText>

                </InnerButtonWrap>
            </OuterButtonWrap>
        </Wrap>
    )
}

export default PremButton

const OuterButtonWrap = styled.div`
       position: relative;
       z-index: 1;
       border-radius: inherit;
       transition: box-shadow 300ms ease;
       will-change: box-shadow;       
       box-shadow: ${(props) => (props.$selected ? "0 0.05em 0.05em -0.01em rgba(5, 5, 5, 1), 0 0.01em 0.01em -0.01em rgba(5, 5, 5, 0.5), 0.15em 0.3em 0.1em -0.01em rgba(5, 5, 5, 0.25)" : "0 0 0 0 rgba(5, 5, 5, 1), 0 0 0 0 rgba(5, 5, 5, 0.5), 0 0 0 0 rgba(5, 5, 5, 0.25);")};       
       `

const InnerButtonWrap = styled.div`
    --inset: 0.035em;
    position: relative;
    z-index: 1;
    border-radius: inherit;
    padding: .6em 1.2em;
    background-image: linear-gradient(135deg,rgba(230, 230, 230, 1), rgba(180, 180, 180, 1));        
    
    transition: box-shadow 300ms ease, clip-path 250ms ease,
    background-image 250ms ease, transform 250ms ease;
    will-change: box-shadow, clip-path, background-image, transform;
    overflow: clip;
    clip-path: inset(0 0 0 0 round 999vw);
    box-shadow: ${(props) => (props.$selected ? "0.1em 0.15em 0.05em 0 inset rgba(5, 5, 5, 0.75), -0.025em -0.03em 0.05em 0.025em inset rgba(5, 5, 5, 0.5), 0.25em 0.25em 0.2em 0 inset rgba(5, 5, 5, 0.5), 0 0 0.05em 0.5em inset rgba(255, 255, 255, 0.15), 0 0 0 0 inset rgba(255, 255, 255, 1), 0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25), -0.075em -0.12em 0.2em 0.1em inset rgba(5, 5, 5, 0.25);" : "0 0 0 0 inset rgba(5, 5, 5, 0.1), -0.05em -0.05em 0.05em 0 inset rgba(5, 5, 5, 0.25), 0 0 0 0 inset rgba(5, 5, 5, 0.1), 0 0 0.05em 0.2em inset rgba(255, 255, 255, 0.25), 0.025em 0.05em 0.1em 0 inset rgba(255, 255, 255, 1), 0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25), -0.075em -0.25em 0.25em 0.1em inset rgba(5, 5, 5, 0.25);")};            
    transform: ${(props) => (props.$selected ? "scale(0.975)" : "scale(1)")};            
    
    
    `

const Wrap = styled.button`

outline: ${props => props.$selected ? "1.5px solid var(--active-choice-color)" : "1.5px solid rgba(128, 128, 128, 0.4)"} ;   
outline-offset: -4px; 
    all: unset;
    scroll-snap-align: start; 
    /* padding: ${(props) => (props.pad)}!important;
    min-width: ${props => (props.$fullWidth ? '100%' : 'max-content')};
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    position: relative;
    border-style: none;
    border-width: 1px; */
    font-family: var(--button-font);
    text-transform: var(--button-case);
    cursor: pointer;
    flex: 0;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    position: relative;
    border-radius: 999vw;
   
    background-color: rgba(0, 0, 0, 0.75);
    box-shadow: -0.15em -0.15em 0.15em -0.075em rgba(5, 5, 5, 0.25),
        0.0375em 0.0375em 0.0675em 0 rgba(5, 5, 5, 0.1);

&:disabled {
    cursor: not-allowed;
    opacity: 0.35;
}

    &:after {
        content: "";
        position: absolute;
        z-index: 0;
        width: calc(100% + 0.3em);
        height: calc(100% + 0.3em);
        top: -0.15em;
        left: -0.15em;
        border-radius: inherit;
        background: linear-gradient(-135deg,
                rgba(5, 5, 5, 0.5),
                transparent 20%,
                transparent 100%);
        filter: blur(0.0125em);
        opacity: 0.25;
        mix-blend-mode: multiply;

    }

    &:hover ${OuterButtonWrap} {
        box-shadow: 0 0 0 0 rgba(5, 5, 5, 1), 0 0 0 0 rgba(5, 5, 5, 0.5),
             0 0 0 0 rgba(5, 5, 5, 0.25);
    }

   

    &:not(:disabled):hover ${InnerButtonWrap} {
        clip-path: inset(clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px) clamp(1px, 0.0625em, 2px) round 999vw);
        box-shadow:
        0.1em 0.15em 0.05em 0 inset rgba(5, 5, 5, 0.75),
        -0.025em -0.03em 0.05em 0.025em inset rgba(5, 5, 5, 0.5),
        0.25em 0.25em 0.2em 0 inset rgba(5, 5, 5, 0.5),
        0 0 0.05em 0.5em inset rgba(255, 255, 255, 0.15),
        0 0 0 0 inset rgba(255, 255, 255, 1),
        0.12em 0.12em 0.12em inset rgba(255, 255, 255, 0.25),
        -0.075em -0.12em 0.2em 0.1em inset rgba(5, 5, 5, 0.25);
    }
    
    &:not(:disabled):hover ${InnerButtonWrap} {
        transform: scale(0.975);
    }
    &:not(:disabled):hover ${InnerButtonWrap} span {
        transform: scale(0.975);
    }
   

    `
const InnerText = styled.div`

            position: relative;
            z-index: 4;
            font-size: 13px;
            letter-spacing: 2px;
            color: ${(props) => (props.$selected ? `var(--secondary-btn-color)` : `var(--secondary-btn-color)`)};
            transform: ${(props) => (props.$selected ? "scale(0.975)" : "scale(1)")};     
            
            line-height: .8;
            filter: ${props => props.$selected ? "drop-shadow(0 2px 8px var(--active-choice-color))" : "none"} ;
            ${'' /* text-shadow: ${props => props.$selected ? "0 0 0 var(--active-choice-color) 0 2px 8px var(--active-choice-color) 0 2px 8px var(--active-choice-color)" : "none"} ; */}
            text-align: center;
            font-weight: 500;
            transition: transform 250ms ease;
            display: flex;
            flex-direction: column;
            gap: 6px;
            will-change: transform;
            white-space: nowrap;   
            ${'' /* filter: ${(props) => (props.$selected ? `drop-shadow(0 0 0px ${props.$color}) drop-shadow(0 0 2px ${props.$color}aa) drop-shadow(0 0 10px ${props.$color})  drop-shadow(0 0 15px ${props.$color}aa)` : "none")};          */}
            
            & span {
                display: block;
            }
            & span.price {
                /* font-weight: 700; */
                font-size: 20px;
                
            }
       
`



